import React, {useContext, useEffect, useState} from 'react';
import {OrdersSadanContext} from "../OrdersSadanContext";
import axios from "axios";
import {prefixUrl} from "../../../utils/utilsData";
import FactorSellSclRlookUp from "../../SellSclFactor/FactorSellSclRlookUp";
import PaymentType from "./PaymentType";
import DatePickerSelect from "./DatePickerSelect";
import TimePickOrderSadan from "./TimePickOrderSadan";
import PaymentCode from "./PaymentCode";
import DescriptionOrderSadan from "./DescriptionOrderSadan";
import {toast} from "react-toastify";
import {initialSetData} from "../OrdersSadan";
import {useNavigate} from "react-router-dom";
import SendPrice from "./SendPrice";
import DatePickerSelect2 from "./DatePickerSelect2";
import DiscountCode from "./DiscountCode";

function FactorKolOrderSadan() {
  const helper = useContext(OrdersSadanContext);
  const setData = helper.setData
  const data = helper.data


  const [rlookupIds, setRlookUpIds] = useState({
    addressRLookUpId: "-1", customerRLookUpId: "-1",
  })

  const getData = async () => {
    const res1 = await axios.get(prefixUrl() + `/cartTable/?request=initialData`)
    if (res1.data.status) {
      setRlookUpIds(res1.data.data);
      console.log(res1.data.data)
    }
  }

  useEffect(() => {
    void getData();
  }, []);

  const navigateTo = useNavigate()
  const submitHandler = async () => {

    const sendData = {request: "cartSubmit", data}
    const res = await axios.post(prefixUrl() + '/cartTable/', sendData)

    if (res.data.status) {
      toast.success(res.data.message)
      if (data.mode === 'add') {
        setData({...initialSetData, reload: data.reload + 1})
      } else {
        // Reset state so that usePrompt doesn't block the navigateTo(-1) 
        setData({...initialSetData});
        setTimeout(() => navigateTo(-1), 0);
      }
    } else {
      toast.error(res.data.message)
    }
  }

  try {
    return (<div className={"kol-package"}>
      <div className={'kol__title'}> سبد سفارش</div>

      <div className={''}>
        <FactorSellSclRlookUp
          rlookupId={rlookupIds.customerRLookUpId}
          defaultCaption={"شخص"}
          captionAfterSelect={""}
          valueAfterSelect={data.customerId ? (data.customerName + " (" + data.customerId + ")") : undefined}

          functionAfterSelect={(backObject) => {
            setData({
              ...data, customerId: backObject.na_1399, customerName: backObject.na_1388, // deliveryName: backObject.na_124
            })
          }}
        />

        <FactorSellSclRlookUp
          rlookupId={rlookupIds.addressRLookUpId}
          defaultCaption={"آدرس"}
          captionAfterSelect={"کد آدرس: "}
          valueAfterSelect={data?.addressId}
          functionAfterSelect={(backObject) => {
            setData({...data, addressId: backObject.na_1393,})
          }}
          variables={JSON.stringify({na_1399: data.customerId})}
          variableIsStringify={true}
        />

        <div>
          <DatePickerSelect2/>
        </div>

        <div>
          <DatePickerSelect/>
        </div>

        <div>
          <TimePickOrderSadan/>
        </div>
        <div>
          <SendPrice/>
        </div>
        <div>
          <PaymentType/>
        </div>
        <div>
          <PaymentCode/>
        </div>
        <div>
          <DiscountCode/>
        </div>
        <div>
          <DescriptionOrderSadan/>
        </div>

        <div className={"text-center mt-5"}>
          <button
            onClick={submitHandler}
            className={"btnCustom btnSubmit width__142"}>ثبت
          </button>
        </div>
      </div>
    </div>);
  } catch (error) {
    return <>{error.toString()}</>
  }
}

export default FactorKolOrderSadan;